/**
 * Склоняет слово «шаг» по числу: 1 шаг, 2 шага, 5 шагов.
 */
export const getStepsWord = (count: number): string => {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return 'шаг';
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return 'шага';
  }

  return 'шагов';
};
